var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-right"},[_c('export',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"name":"staff-survey-data","text":"Export full dataset"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }